<div class="loyalty" [ngStyle]="{
  'border-color' : withBorder ? 'var(--loyalty-text)' : 'var(--loyalty-main)',
  'height' : height
}">
  <div class="loyalty__info">
    <div class="loyalty__info-title">{{info.title}}</div>
    <div class="loyalty__info-text">{{info.text}}</div>
  </div>
  <div class="loyalty__circle" [ngStyle]="{ 'width' : circleWidth }">
    <div class="loyalty__circle-content">{{pointsValue}}</div>
  </div>
  <img class="loyalty__decor" src="./assets/images/loyalty-decor.svg" alt="background decor"/>
</div>
